export const getTokenAuthStorage = () => {
  try {
    const auth = atob(localStorage.getItem('ECCO_IND_AUTH'));
    return JSON.parse(auth);
  } catch (e) {
    return null;
  }
};